export const ALLOCATION_WISH_REQUESTING = 'ALLOCATION_WISH_REQUESTING';
export const ADD_ALLOCATION_WISH_REQUEST = 'ADD_ALLOCATION_WISH_REQUEST';
